module.exports = __webpack_public_path__ + "static/media/arrow-left.55d89f09.svg";